import { render, staticRenderFns } from "./ScanProduct.vue?vue&type=template&id=427ffd54&"
import script from "./ScanProduct.vue?vue&type=script&lang=js&"
export * from "./ScanProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports